import React, { createContext, useState, type ReactNode } from 'react';
import {
  type FunnelPlacements,
  type PlacementLossAversionPosition,
} from '@bbkAdminRedux/rtkq/placements.utils';

type FunnelPlacementContextType = {
  funnelPlacement: FunnelPlacements;
  setFunnelPlacement: React.Dispatch<React.SetStateAction<FunnelPlacements>>;
  lossAversionErrors: PlacementLossAversionPosition[];
  setLossAversionErrors: React.Dispatch<
    React.SetStateAction<PlacementLossAversionPosition[]>
  >;
};
export const FunnelPlacementContext = createContext<FunnelPlacementContextType>(
  {} as FunnelPlacementContextType
);

type FunnelPlacementProps = {
  funnelPlacement: FunnelPlacements;
  children: ReactNode;
};

export const FunnelPlacementProvider: React.FC<FunnelPlacementProps> = ({
  funnelPlacement: currentFunnelPlacement,
  children,
}) => {
  const [funnelPlacement, setFunnelPlacement] = useState<FunnelPlacements>(
    currentFunnelPlacement
  );
  const [lossAversionErrors, setLossAversionErrors] = useState<
    PlacementLossAversionPosition[]
  >([]);
  return (
    <FunnelPlacementContext.Provider
      value={{
        funnelPlacement,
        setFunnelPlacement,
        lossAversionErrors,
        setLossAversionErrors,
      }}
    >
      {children}
    </FunnelPlacementContext.Provider>
  );
};
